import jsPDF from "jspdf";

export const getPdfViewSalesAreaReportingTableRevenue = ({ data, headers, filename }) => {
  const doc = new jsPDF({
    orientation: "l",
    unit: "pt",
    format: "a4",
  });

  const pageDimensions = {
    // NEW CODE
    height: 595.28,
    width: 841.89,
  };

  const pageMargin = 30;

  const liveArea = {
    width: pageDimensions.width - pageMargin,
    height: pageDimensions.height - pageMargin,
  };

  const padding = 7;
  doc.setFontSize(12);

  doc.setTextColor(255, 255, 255);
  const xPositions = [];

  const standardRowHeight = 15;

  // HEADERS
  doc.setFillColor(48, 63, 159);
  doc.setDrawColor(48, 63, 159);
  doc.rect(pageMargin, pageMargin, liveArea.width - pageMargin - 3.5 / 2, standardRowHeight + padding * 2, "F");
  headers.forEach((heading, index) => {
    // If you decide to add xPos to the header mappings this will fire
    if (heading.hasOwnProperty("xPos")) {
      doc.text(String(heading.label), heading.xPos, pageMargin + standardRowHeight + padding - 3.5);
      xPositions.push(heading.xPos);
    } else {
      // get x position for heading
      const xPositionForCurrentHeader = pageMargin + index * (liveArea.width / headers.length);
      // need to position our text within our live area
      const yPositionForHeaders = pageMargin;
      doc.text(
        String(heading.label),
        index === 0 ? xPositionForCurrentHeader : xPositionForCurrentHeader + padding,
        yPositionForHeaders
      );

      // Push x position of current header to xPositions array
      xPositions.push(index === 0 ? xPositionForCurrentHeader : xPositionForCurrentHeader + padding);
    }
  });

  const baseYPosForRows = pageMargin + standardRowHeight + padding * 2;
  let nextYPos = baseYPosForRows;

  // ROWS
  data.forEach((row, rIndex) => {
    // Here we are going to collect all columns potential max heights (below)
    // Before we determine the nextYPosition we have to grab the tallest value
    // and add that to the previous height.
    const rowHeights = [];
    /*
     *
     * Row styles go here (lines, images, shapes)
     *
     * */

    // COLUMNS
    headers.forEach((column, colIndex) => {
      // Using the .splitTextToSize method will take a
      // string and a width parameter. It will return an array of strings.
      let width = xPositions[colIndex + 1] - xPositions[colIndex];
      if (colIndex === 6) {
        width = 90;
      }
      const longText = doc.splitTextToSize(row[column.key] == null ? "" : String(row[column.key]), width);

      // To get row height, we will use the .getLineHeight method
      // This method returns a line height based on set text
      // size for the document. Multiplied by the array length, your
      // value should be at minimum a standard line of text, OR at
      // maximum the amount of lines of text by line height
      const rowHeight = longText.length * doc.getLineHeight();

      // We need to push this height value to the array of heights for
      // the row (above)
      rowHeights.push(rowHeight);

      /*
       *
       *  Column styles go here (lines, images, shapes)
       *
       * */

      doc.setFontType("normal");

      if (colIndex === 0) {
        doc.setDrawColor(255, 255, 255);

        switch (row.rowType) {
          case "salesAreaHead":
            doc.setFillColor(121, 134, 203);
            doc.setDrawColor(121, 134, 203);
            doc.setTextColor(255, 255, 255);
            break;
          case "totalHead":
            doc.setFillColor(48, 63, 159);
            doc.setDrawColor(48, 63, 159);
            doc.setTextColor(255, 255, 255);
            break;
          case "vatRowsHead":
            doc.setFillColor(237, 239, 248);
            doc.setDrawColor(237, 239, 248);
            doc.setTextColor(0, 0, 0);
            break;
          case "vatRowsHeadTotal":
            doc.setFillColor(237, 239, 248);
            doc.setDrawColor(237, 239, 248);
            doc.setTextColor(0, 0, 0);
            doc.setFontType("bold");
            break;
          default:
            doc.setFillColor(255, 255, 255);
            doc.setDrawColor(255, 255, 255);
            doc.setTextColor(0, 0, 0);
        }
      } else {
        switch (row.rowType) {
          case "salesAreaHead":
            doc.setFillColor(121, 134, 203);
            doc.setDrawColor(121, 134, 203);
            doc.setTextColor(255, 255, 255);
            break;
          case "vatRowsHead":
            doc.setFillColor(237, 239, 248);
            doc.setDrawColor(237, 239, 248);
            doc.setTextColor(0, 0, 0);
            break;
          case "vatRowsHeadTotal":
            doc.setFillColor(237, 239, 248);
            doc.setDrawColor(237, 239, 248);
            doc.setTextColor(0, 0, 0);
            doc.setFontType("bold");
            break;
          case "paymentTypeHead":
            doc.setFillColor(121, 134, 203);
            doc.setDrawColor(121, 134, 203);
            doc.setTextColor(255, 255, 255);
            break;
          case "vatRows":
            doc.setFillColor(255, 255, 255);
            doc.setDrawColor(255, 255, 255);
            doc.setTextColor(0, 0, 0);
            break;
          case "vatRowsSubtotal":
            doc.setFillColor(255, 255, 255);
            doc.setDrawColor(255, 255, 255);
            doc.setTextColor(0, 0, 0);
            doc.setFontType("bold");
            break;
          case "totalHead":
            doc.setFillColor(48, 63, 159);
            doc.setDrawColor(48, 63, 159);
            doc.setTextColor(255, 255, 255);
            break;
          case "totalPaymentTypeHead":
            doc.setFillColor(48, 63, 159);
            doc.setDrawColor(48, 63, 159);
            doc.setTextColor(255, 255, 255);
            break;
          default:
            doc.setFillColor(48, 63, 159);
            doc.setDrawColor(48, 63, 159);
            doc.setTextColor(255, 255, 255);
        }
      }

      doc.rect(xPositions[colIndex], nextYPos, width, rowHeight + padding + 3.5 / 2, "F");
      doc.text(longText, xPositions[colIndex], nextYPos + padding * 2);
    });

    // Here's the accumulator expression to inform the next row start point
    nextYPos = nextYPos + padding + Math.max(...rowHeights, standardRowHeight);

    // When generating looped data, you may need to add pages manually.
    // The good thing is that we've defined our live area boundaries,
    // and can add a new page when our yPosition exceeds them. We need
    // to take some care to reset the yPosition because if you don't:
    // the yPosition will persist to the next page, and more than likely
    // disappear from view as your yPosition grows.
    if (nextYPos > liveArea.height) {
      doc.addPage();
      nextYPos = baseYPosForRows;
    }
  });

  doc.save(filename);
};
